// Password policy for RCS accounts. MUST stay in sync with the server-side
// check in JBM-TICKETING-Server/v2/auth/controller.js (isStrongPassword).
export const PASSWORD_RULES = [
  { label: "At least 8 characters", test: (v) => (v || "").length >= 8 },
  { label: "One uppercase letter", test: (v) => /[A-Z]/.test(v || "") },
  { label: "One number", test: (v) => /[0-9]/.test(v || "") },
  { label: "One special character", test: (v) => /[^A-Za-z0-9]/.test(v || "") },
];

export const isPasswordValid = (v) => PASSWORD_RULES.every((rule) => rule.test(v || ""));
